import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { InfoDialogComponent } from '../../../../shared/dialog/components/dialogs/info-dialog/info-dialog.component';
import { DialogService } from '../../../../shared/dialog/services/dialog.service';
import { PasswordService } from '../password.service';

@Component({
  selector: 'password-forgot',
  templateUrl: './password-forgot.component.html',
})
export class PasswordForgotComponent implements OnDestroy {

  public email: string = null;
  public errorMessages: string[] = [];

  private subscription: Subscription = new Subscription();

  /**
   * Constructor
   *
   * @param {PasswordService} passwordService
   * @param {DialogService} dialogService
   * @param {TranslateService} translate
   * @param {Router} router
   */
  public constructor(
    private passwordService: PasswordService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private router: Router,
  ) {
  }

  /**
   * On submitting the form
   *
   * @return void
   */
  public onSubmit(): void {
    this.errorMessages = [];

    this.passwordService.sendPasswordForgot(this.email).subscribe(
      () => {
        this.email = '';
        this.showMessage();
      },
      (response) => {

        if (response.error.limit_exceeded) {

          const data: Object = {
            title: response.error.message.title,
            text: response.error.message.text,
          };

          const dialog = this.dialogService.open(InfoDialogComponent, data);

          this.subscription.add(
            dialog.dialogClosed().subscribe(() => {
              this.router.navigate(['login']).then();
            }),
          );
        } else if (!response.error.validation) {
          this.errorMessages = response.error.messages.email;
        } else {
          this.showMessage();
        }
      },
    );
  }

  /**
   * When the component is destroyed unsubscribe
   *
   * @return void
   */
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Show the feedback message
   *
   * @return void
   */
  private showMessage(): void {
    this.translate.get('auth.messages.password_forgot', {email: this.email}).subscribe((translated: string) => {
      const data: Object = {
        title: null,
        text: translated,
      };

      const dialog = this.dialogService.open(InfoDialogComponent, data);

      this.subscription.add(
        dialog.dialogClosed().subscribe(() => {
          this.router.navigate(['login']).then();
        }),
      );
    });
  }
}
